import { Badge, Grid } from "@mui/material";
import LeadEstimate from "../lead/estimate/LeadEstimate";
import LeadSurvey from "../lead/survey/LeadSurvey";
import { useSelector } from "react-redux";
import LeadCompletion from "../lead/completion/LeadCompletion";
import PageInfoTitle from "../../../components/pageTitle/PageInfoTitle";
import { useEffect, useState } from "react";
import CustomButton from "../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";
import { InfoOutlined } from "@mui/icons-material";
import { getConfirmationToolTipAction } from "../../../store/reducers/clientConfirmationSlice";
import AlertConfirmation from "./AlertConfirmation";
import LeadQuote from "../lead/quote/LeadQuote";

interface ManageLeadsPageProps {
  onButtonClick: () => void;
  isDisabledConfirmation?: boolean;
}

const ManageLeadsPage: React.FC<ManageLeadsPageProps> = ({
  onButtonClick,
  isDisabledConfirmation,
}) => {
  const {
    userProfile,
    user,
    leadEstimateModulePermission,
    leadQuotationModulePermission,
    leadCompletionModulePermission,
    leadConfirmationModulePermission,
  } = useSelector((state: any) => state?.user);

  const dispatch = useDispatch();
  const { toolTipResponse } = useSelector((state: any) => state?.confirmation);
  const { leadDetails } = useSelector((state: any) => state.lead);

  useEffect(() => {
    if (leadDetails?.lead?.generated_id) {
      dispatch(getConfirmationToolTipAction(leadDetails?.lead?.generated_id));
    }
  }, [leadDetails?.lead?.generated_id]);
  const [isAdmin, setIsAdmin] = useState<null | boolean>(null);

  useEffect(() => {
    if (leadDetails || user) {
      setIsAdmin(
        user?.user?.roles?.includes("TENANT") ||
          user?.user?.roles?.includes("Admin") ||
          user?.user?.roles?.includes("Owner")
          ? true
          : false,
      );
    }
  }, [leadDetails, user]);

  const [confirmationAlertOpen, setConfirmationAlertOpen] = useState(false);

  const onConfirmationAlertClose = () => {
    setConfirmationAlertOpen(false);
  };

  const onAlertConfirmationOpen = () => {
    setConfirmationAlertOpen(true);
  };

  return (
    <>
      {confirmationAlertOpen && (
        <AlertConfirmation
          open={confirmationAlertOpen}
          onHide={onConfirmationAlertClose}
          title={"Alert"}
          setAlertModelShow={setConfirmationAlertOpen}
        />
      )}
      {/* <PageTitle title="Manage Leads" /> */}
      <Grid container spacing={2} className="modalBackdrop">
        {(userProfile?.roles?.includes("TENANT") ||
          userProfile?.roles?.includes("Admin") ||
          userProfile?.roles?.includes("Owner") ||
          leadEstimateModulePermission?.create) && (
          <>
            <LeadEstimate />
          </>
        )}
        <LeadSurvey />
        {(userProfile?.roles?.includes("TENANT") ||
          userProfile?.roles?.includes("Admin") ||
          userProfile?.roles?.includes("Owner") ||
          leadQuotationModulePermission?.create) && (
          <>
            {userProfile?.features?.includes("Professional Quotes") ? (
              <LeadQuote screenType="quotation" />
            ) : (
              <LeadEstimate screenType="quotation" />
            )}
          </>
        )}

        {(userProfile?.roles?.includes("TENANT") ||
          userProfile?.roles?.includes("Admin") ||
          userProfile?.roles?.includes("Owner") ||
          leadConfirmationModulePermission?.create) && (
          <>
            <Grid item xs={12} md={2.4}>
              <Badge
                badgeContent={
                  toolTipResponse?.isSeen === false &&
                  toolTipResponse?.isNewResponse === true ? (
                    <InfoOutlined />
                  ) : (
                    0
                  )
                }
                color="error"
                sx={{
                  width: "100%",
                  "& .MuiBadge-badge": {
                    // override the badge's default styling
                    backgroundColor: "red", // make the background transparent
                    color: "white", // use the icon's color
                    padding: 0, // remove padding around the icon
                    minWidth: "auto", // remove default badge width
                    height: "auto", // remove height constraint
                    borderRadius: "50%", // remove border radius
                    marginRight: "0px",
                  },
                }}
              >
                <CustomButton
                  style={{
                    padding: "10px 30px",
                    height: "36px",
                    width: "100% !important",
                  }}
                  sx={{ width: "100%" }}
                  title={
                    isAdmin || leadConfirmationModulePermission?.create
                      ? `Confirmation`
                      : ""
                  }
                  // disabled={toolTipResponse?.isNewResponse ? false :
                  //   leadDetails?.lead?.status === "CONFIRMED" ||
                  //   leadDetails?.lead?.status === "JOB" ||
                  //   leadDetails?.lead?.status === "COMPLETED" ||
                  //   leadDetails?.lead?.status === "PROVISIONAL"
                  //     ? false
                  //     : true
                  // }
                  onClick={
                    leadDetails?.lead?.status === "QUOTE" ||
                    leadDetails?.lead?.status === "CONFIRMED" ||
                    leadDetails?.lead?.status === "JOB" ||
                    leadDetails?.lead?.status === "COMPLETED" ||
                    leadDetails?.lead?.status === "PROVISIONAL" ||
                    leadDetails?.lead?.status === "DISPUTE" ||
                    leadDetails?.lead?.status === "LOST" ||
                    leadDetails?.lead?.status === "AWAITING" ||
                    leadDetails?.lead?.status === "DEBTOR" ||
                    leadDetails?.lead?.status === "EXTERNAL" || leadDetails?.lead?.status === "STORAGE"
                      ? onButtonClick
                      : onAlertConfirmationOpen
                  }
                />
              </Badge>
              {/* <PageInfoTitle
                button={
                  isAdmin || leadConfirmationModulePermission?.create
                    ? `Confirmation`
                    : ""
                }
                title=""
                leadId={leadDetails?.lead?.generated_id}
                disabled={
                  leadDetails?.lead?.status === "CONFIRMED" ||
                  leadDetails?.lead?.status === "JOB" ||
                  leadDetails?.lead?.status === "COMPLETED" ||
                  leadDetails?.lead?.status === "PROVISIONAL"
                    ? false
                    : true
                }
                onClick={onButtonClick}
              /> */}
              {/* <CustomButton
                style={{ padding: "10px 30px", height: "36px",width:'100%' }}
                title={"Confirmation"}
                onClick={onButtonClick}
                disabled={isDisabledConfirmation}
              /> */}
            </Grid>
          </>
        )}
        {(userProfile?.roles?.includes("TENANT") ||
          userProfile?.roles?.includes("Admin") ||
          userProfile?.roles?.includes("Owner") ||
          leadCompletionModulePermission?.create) && (
          <>
            <LeadCompletion />
          </>
        )}
      </Grid>
    </>
  );
};
export default ManageLeadsPage;
